import React, { createContext, useState, useEffect } from "react";

export const GoogleApiContext = createContext();

export const GoogleApiProvider = ({ children, googleApiKey }) => {
  const [isApiLoaded, setApiLoaded] = useState(false);

  useEffect(() => {
    if (window.google && window.google.maps) {
      console.log("✅ Google API already loaded.");
      setApiLoaded(true);
      return;
    }

    if (document.querySelector(`script[src*="maps.googleapis.com"]`)) {
      console.log("✅ Google API script already exists.");
      return;
    }

    console.log("🚀 Adding Google API script...");
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&libraries=places`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      console.log("✅ Google API script loaded.");
      setApiLoaded(true);
    };

    document.head.appendChild(script);
  }, [googleApiKey]);

  return (
    <GoogleApiContext.Provider value={{ isApiLoaded }}>
      {children}
    </GoogleApiContext.Provider>
  );
};
